var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialTiktok28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.276 8.252a4.477 4.477 0 0 1-.387-.225 5.442 5.442 0 0 1-.994-.844 4.689 4.689 0 0 1-1.12-2.312h.004c-.085-.5-.05-.823-.045-.823h-3.376v13.056c0 .175 0 .348-.008.52l-.003.063c0 .01 0 .02-.002.03v.007a2.867 2.867 0 0 1-1.443 2.275c-.425.243-.907.37-1.396.369a2.857 2.857 0 0 1-2.849-2.867 2.857 2.857 0 0 1 2.848-2.867c.298 0 .594.047.877.139l.005-3.438a6.272 6.272 0 0 0-4.833 1.414 6.627 6.627 0 0 0-1.446 1.783c-.143.245-.68 1.233-.745 2.835-.041.91.232 1.853.362 2.242v.008a6.6 6.6 0 0 0 .917 1.672c.417.53.91.994 1.462 1.38v-.008l.008.008c1.635 1.11 3.447 1.038 3.447 1.038.314-.013 1.365 0 2.558-.566 1.324-.627 2.078-1.561 2.078-1.561a6.492 6.492 0 0 0 1.132-1.881 7.048 7.048 0 0 0 .407-2.152v-6.926c.041.024.587.385.587.385s.785.504 2.012.832c.88.234 2.065.283 2.065.283V8.769c-.415.045-1.259-.086-2.122-.517Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktok28);
export default __webpack_public_path__ + "static/media/social-tiktok_28.8a5a14c0.svg";
export { ForwardRef as ReactComponent };